import { useState, useCallback } from "react";
import {
  getInvoices,
  getInvoiceStats,
  payCommission,
  downloadInvoicePDF,
  exportInvoices,
  getInvoiceTransferDetails,
  getInvoicesByOrder,
} from "../../../../api/marketplace";

export function useInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInvoices = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getInvoices(params);
      setInvoices(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStats = useCallback(async () => {
    try {
      const res = await getInvoiceStats();
      setStats(res.data);
    } catch (err) {
      console.error("Failed to fetch invoice stats:", err);
    }
  }, []);

  const pay = useCallback(async (data) => {
    const res = await payCommission(data);
    await fetchInvoices();
    return res.data;
  }, [fetchInvoices]);

  const downloadPDF = useCallback(async (id) => {
    const res = await downloadInvoicePDF(id);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice_${id}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, []);

  const exportCSV = useCallback(async (params = {}) => {
    const res = await exportInvoices(params);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "invoices_export.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, []);

  const getTransferDetails = useCallback(async (id) => {
    const res = await getInvoiceTransferDetails(id);
    return res.data;
  }, []);

  const getByOrder = useCallback(async (orderId) => {
    const res = await getInvoicesByOrder(orderId);
    return res.data;
  }, []);

  return {
    invoices,
    stats,
    loading,
    error,
    fetchInvoices,
    fetchStats,
    pay,
    downloadPDF,
    exportCSV,
    getTransferDetails,
    getByOrder,
  };
}
